<template>
  <div class="appfacilita">
    <div class="widget">
      <div class="widget-body">
        <div class="d-flex justify-content-between align-items-center">
          <div class="state">
            <h4>AppFacilita CRM <small v-if="!activeIntegration">(Inativo)</small></h4>
          </div>
          <div class="icon">
            <div v-if="activeIntegration">
              <font
                title="Configurações"
                size="6"
                color="black"
                @click.prevent="toogleUpdateIntegration()">
                <i class="ik ik-settings" />
              </font>
            </div>
            <div v-else>
              <font
                title="Configurações"
                size="6"
                color="gray">
                <i class="ik ik-settings" />
              </font>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-between align-items-center">
          <small class="text-small mt-10 d-block">
            <toggle-button
              tag="appfacilita"
              class="mb-1"
              :width="90"
              :height="30"
              :font-size="15"
              :value="activeIntegration"
              :sync="true"
              :labels="{checked: 'Ativo', unchecked: 'Ativar'}"
              @change="toogleIntegration" />
          </small>
          <font
            title="Tutorial"
            size="6"
            color="black"
            @click.prevent="openTutorial">
            <i class="ik ik-youtube" />
          </font>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      id="confirmDelete"
      ref="confirmDelete"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-dialog-centered"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <h4 class="modal-title">Você tem certeza que deseja remover a integração com AppFacilita CRM?</h4>
          </div>
          <div class="modal-footer">
            <div class="buttons">
              <button
                type="button"
                class="btn btn-outline-secondary"
                data-dismiss="modal">Não</button>
              <button
                type="button"
                class="btn btn-primary"
                @click.prevent="deleteIntegration">Sim</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      id="updateIntegration"
      ref="updateIntegration"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-dialog-centered"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Configurar AppFacilita CRM</h4>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <ErrorAlert :error="error" />
            <p class="text-center">
              Para solicitar suas credencias entre em contato com AppFacilita CRM.
            </p>
            <p class="text-center">
              Email:
              <a
                class="link"
                href="mailto:suporte@appfacilita.com"
                target="_blank">
                suporte@appfacilita.com
              </a>
            </p>
            <p class="text-center">
              Whastapp:
              <a
                class="link"
                href="https://wa.me/+551149495909"
                target="_blank">
                +55 (11) 4949-5909
              </a>
            </p>
            <p class="text-center">
              Chat: Via sistema (Painel e App)
            </p>
            <div class="form-group row">
              <label
                for="apiInstance"
                class="col-sm-4 col-form-label">api-instance</label>
              <div class="col-sm-8">
                <input
                  id="apiInstance"
                  type="text"
                  class="form-control"
                  v-model="apiInstance">
              </div>
            </div>
            <div class="form-group row">
              <label
                for="apiKey"
                class="col-sm-4 col-form-label">api-key</label>
              <div class="col-sm-8">
                <input
                  id="apiKey"
                  type="password"
                  class="form-control"
                  v-model="apiKeyProtected">
              </div>
            </div>
            <div class="form-group row">
              <label
                for="tokenUser"
                class="col-sm-4 col-form-label">token-user</label>
              <div class="col-sm-8">
                <input
                  id="tokenUser"
                  type="password"
                  class="form-control"
                  v-model="tokenUserProtected">
              </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-4 col-form-label">Usuário</label>
              <div class="col-sm-8">
                <select
                  class="form-control"
                  id="userId"
                  v-model="userId">
                  <option
                    v-for="option in usersOptions"
                    :key="option.value"
                    :value="option.value">
                    {{ option.text }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <div class="buttons">
              <button
                type="button"
                class="btn btn-primary"
                :disabled="!configReady"
                @click.prevent="saveIntegration">{{ labelSubmit }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      id="successIntegration"
      ref="successIntegration"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-sm modal-dialog-centered"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-center">
            <h5 class="modal-title">Integração com a AppFacilita CRM atualizada com sucesso!</h5>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-secondary"
              data-dismiss="modal">OK</button>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      id="uninstallIntegration"
      ref="uninstallIntegration"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-sm modal-dialog-centered"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-center">
            <h5 class="modal-title">Integração AppFacilita CRM removida com sucesso!</h5>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-secondary"
              data-dismiss="modal">OK</button>
          </div>
        </div>
      </div>
    </div>
    <tutorial-video-modal
      ref="tutorialAppFacilita"
      title="Tutorial AppFacilita CRM"
      video-url="https://www.youtube.com/embed/AgFnEQx3NuA" />
  </div>
</template>

<script>
import loopback from '@/services/loopback'
import TutorialVideoModal from '@/components/Common/TutorialVideoModal.vue'

export default {
  name: 'IntegrationAppFacilita',
  components: {
    TutorialVideoModal
  },
  data () {
    return {
      error: null,
      integration: null,
      configReady: false,
      apiInstance: null,
      apiKey: null,
      tokenUser: null,
      userId: null,
      usersOptions: [],
      usersApi: [],
      isLoadingUsers: false
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.loadIntegration()
        .then(_ => {
          this.loadUsers()
        })
    })
  },
  methods: {
    loadIntegration () {
      return loopback
        .get(`/integrations?filter[where][gateway]=appfacilita`)
        .then(integrations => {
          this.integration = integrations.pop()
          if (this.integration && this.integration.metadata) {
            this.apiInstance = this.integration.metadata.apiInstance
            this.apiKey = this.integration.metadata.apiKey
            this.tokenUser = this.integration.metadata.tokenUser
            this.userId = this.integration.metadata.userId
          }
        })
        .catch(err => { this.$emit('onError', err) })
    },
    saveIntegration () {
      if (this.apiInstance && this.apiKey && this.tokenUser && this.configReady) {
        this.error = null
        const integrationParams = {
          gateway: 'appfacilita',
          webhook: true,
          webhookConstraint: {
            metadata: {
              api4comGateway: 'appfacilita'
            }
          },
          metadata: {
            apiInstance: this.apiInstance,
            apiKey: this.apiKey,
            tokenUser: this.tokenUser,
            webhookUrl: `${process.env.API4COM_BASE_URL_API}${process.env.API4COM_VERSION_API}/integrations/webhook`,
            webhookVersion: 'v1.4',
            webhookTypes: ['channel-hangup']
          }
        }
        const userFound = this.usersApi.find(user => user.id === this.userId)
        if (userFound) {
          integrationParams.metadata.userId = userFound.id
          integrationParams.metadata.userName = userFound.first_name
          integrationParams.metadata.userEmail = userFound.email
        }
        if (this.integration) integrationParams.id = this.integration.id
        loopback
          .patch('/integrations', integrationParams)
          .then(integration => {
            this.integration = integration
            $(this.$refs.updateIntegration).modal('hide')
            $(this.$refs.successIntegration).modal('show')
          })
          .catch(err => {
            this.error = err
            // TEL-2243: o `friendly` do interceptor ja resolve `details.messages` pelo
            // FIELD_MESSAGES, mantem em pt-BR o que o backend ja manda traduzido e nomeia
            // o campo quando nao ha texto proprio. Montar `lines` aqui devolvia o texto do
            // LoopBack em ingles e ainda sobrescrevia a traducao.
          })
      } else {
        this.error = {
          message: 'api-instance, api-key e token-user são obrigatórios'
        }
      }
    },
    toogleIntegration (event) {
      if (event.value === true) {
        $(this.$refs.updateIntegration).modal('show')
      } else {
        $(this.$refs.confirmDelete).modal('show')
      }
    },
    toogleUpdateIntegration () {
      $(this.$refs.updateIntegration).modal('show')
    },
    deleteIntegration () {
      if (!this.integration) return
      loopback
        .delete(`/integrations/${this.integration.id}`)
        .then(_ => {
          this.integration = null
          this.apiInstance = null
          this.apiKey = null
          this.tokenUser = null
          this.userId = null
          this.error = null
          this.configReady = false
          this.usersOptions = []
          $(this.$refs.uninstallIntegration).modal('show')
        })
        .finally(_ => {
          $(this.$refs.confirmDelete).modal('hide')
        })
        .catch(err => { this.$emit('onError', err) })
    },
    loadUsers () {
      if (this.isLoadingUsers) return
      this.isLoadingUsers = true
      if (this.apiInstance && this.apiKey && this.tokenUser) {
        return loopback
          .get(`/integrations/appfacilita/users?apiInstance=${this.apiInstance}&apiKey=${this.apiKey}&tokenUser=${this.tokenUser}`)
          .then(users => {
            this.usersApi = users
            if (!this.userId && users[0]) {
              this.userId = users[0].id
            }
            this.usersOptions = []
            users.forEach(user => {
              this.usersOptions.push({
                value: user.id,
                text: `${user.first_name} (${user.email}) (${user.group})`
              })
            })
            this.configReady = true
            this.error = null
            this.isLoadingUsers = false
          })
          .catch(err => {
            this.configReady = false
            if (err.statusCode === 429) this.error = err
            else {
              this.error = {
                message: 'api-instance, api-key e token-user são obrigatórios'
              }
            }
            this.isLoadingUsers = false
          })
      } else {
        this.configReady = false
        this.isLoadingUsers = false
      }
    },
    openTutorial () {
      this.$refs.tutorialAppFacilita.open()
    },
    checkCredentials () {
      if (this.apiInstance && this.apiKey && this.tokenUser) {
        this.loadUsers()
      } else {
        this.configReady = false
      }
    }
  },
  computed: {
    activeIntegration () {
      return this.integration && this.integration.gateway === 'appfacilita'
    },
    labelSubmit () {
      return this.activeIntegration ? 'Salvar' : 'Ativar'
    },
    apiKeyProtected: {
      get () {
        if (this.apiKey) {
          return this.apiKey.replace(/.{28}/, '*'.repeat(28))
        }
        return null
      },
      set (value) {
        this.apiKey = value
      }
    },
    tokenUserProtected: {
      get () {
        if (this.tokenUser) {
          return this.tokenUser.replace(/.{240}/, '*'.repeat(240))
        }
        return null
      },
      set (value) {
        this.tokenUser = value
      }
    }
  },
  watch: {
    apiInstance: function () {
      this.checkCredentials()
    },
    apiKey: function () {
      this.checkCredentials()
    },
    tokenUser: function () {
      this.checkCredentials()
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/Integration/AppFacilita.vue